module.exports = __webpack_public_path__ + "f259aab7d431d804b607dd2ad6eb454d.svg";